import { CommonModule, DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';

@Component({
  selector: 'common-advanced-date-selector',
  imports: [CommonModule, MatDatepickerModule, MatCardModule],
  templateUrl: './advanced-date-selector.component.html',
  styleUrls: ['./advanced-date-selector.component.scss'],
})
export class AdvancedDateSelectorComponent {
  options = ['Custom'];

  selectedOption = 'Custom';
  @Input() selectedDate: string;
  @Input() shouldDisplayCalendar: boolean = true;
  @Input() customClass: boolean = false;
  @Output() applyFilter = new EventEmitter();

  constructor(private readonly datePipe: DatePipe) {}

  selectOption(event: Event, option: string) {
    event.preventDefault();
    event.stopPropagation();
    this.selectedOption = option;
  }

  selectedChange(selectedDate: Date) {
    this.selectedDate = this.formatDate(new Date(selectedDate), 'yyyy-MM-dd');
    this.applyFilter.emit(this.selectedDate);
  }

  displayCalendar(): void {
    this.shouldDisplayCalendar = true;
  }

  public formatDate(date: Date, format: string) {
    return this.datePipe.transform(date, format);
  }
}
